import { rejectHubAccessRequestApi } from 'api/accessRequests/fetchers/rejectHubAccessRequestApi'
import { createUseMutation } from 'api/common/createUseMutation'

export const useRejectHubAccessRequestApi = createUseMutation({
  fetcher: rejectHubAccessRequestApi,
})
